import { render } from "./OfferPage.vue?vue&type=template&id=2d07a061&scoped=true"
import script from "./OfferPage.vue?vue&type=script&lang=js"
export * from "./OfferPage.vue?vue&type=script&lang=js"

import "./OfferPage.vue?vue&type=style&index=0&id=2d07a061&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d07a061"]])

export default __exports__